import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source) {
        super();
        this.b2j_1 = source;
      }
      i2i() {
        return this.b2j_1;
      }
      j2i(position) {
        return position < this.i2i().length ? position : -1;
      }
      x2e() {
        var source = this.i2i();
        var cpos = this.j28_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.j28_1 = cpos;
          return charToTokenClass(c);
        }
        this.j28_1 = source.length;
        return 10;
      }
      t2e() {
        var current = this.j28_1;
        if (current === -1)
          return false;
        var source = this.i2i();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.j28_1 = current;
          return this.m2i(c);
        }
        this.j28_1 = current;
        return false;
      }
      l2i() {
        var current = this.j28_1;
        if (current === -1)
          return current;
        var source = this.i2i();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.j28_1 = current;
        return current;
      }
      d2f(expected) {
        if (this.j28_1 === -1) {
          this.n2i(expected);
        }
        var source = this.i2i();
        var cpos = this.j28_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.j28_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.n2i(expected);
        }
        this.j28_1 = -1;
        this.n2i(expected);
      }
      j2f() {
        this.d2f(_Char___init__impl__6a9atx(34));
        var current = this.j28_1;
        var closingQuote = indexOf(this.i2i(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.v2e();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false ? this.j28_1 - 1 | 0 : this.j28_1;
          var s = this.j28_1 === charSequenceLength(this.i2i()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.i2i(), position));
          var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.f2d(tmp$ret$0, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.i2i(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.i2i(), this.j28_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.j28_1 = closingQuote + 1 | 0;
        return substring(this.i2i(), current, closingQuote);
      }
      l2f(keyToMatch, isLenient) {
        var positionSnapshot = this.j28_1;
        try {
          if (!(this.x2e() === 6))
            return null;
          var firstKey = this.g2f(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.o2i();
          if (!(this.x2e() === 5))
            return null;
          return this.g2f(isLenient);
        }finally {
          this.j28_1 = positionSnapshot;
          this.o2i();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.u27_1.w29_1 ? new (StringJsonLexer())(source) : new (StringJsonLexerWithComments())(source);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
